export default __webpack_public_path__ + "static/media/document-icon.cdeb2526.svg";